import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EventCategoryService } from '@app/services/event-category.service';
import { GlobalUtil } from '@app/modules/common/shared/util/global-util';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { SidebarService } from '@services/sidebar.service';

@Component({
  selector: 'event-category-form',
  templateUrl: './event-category-form.component.html',
  styleUrls: ['./event-category-form.component.scss'],
  providers: [SidebarService]
})

export class EventCategoryFormComponent extends BaseComponent {
  // Local variables
  eventCategoryFormGroup: FormGroup;
  dataLoaded = false;
  globalUtil = GlobalUtil;

  // Input parameters

  // Onput events

  // Contractor
  constructor(
    public activatedRoute: ActivatedRoute,
    public eventCategoryService: EventCategoryService,
    public sidebarService: SidebarService,
    public state: State,
    private formBuilder: FormBuilder
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService: sidebarService,
      state: state,
      modelService: eventCategoryService
    });

    this.setPageVars({
      sidebar: ''
    });

    this.initialFormGroupSetup();
    const id = this.routeParams['id'];
    if (id === undefined) {
      this.dataLoaded = true;
    } else {
      this.modelService.getOne(id).subscribe((result: any) => {
        this.dataLoaded = true;
        this.eventCategoryFormGroup.patchValue(result);
      });
    }
  }

  // All the public methods
  get controls(): any {
    return this.eventCategoryFormGroup.controls;
  }

  public save(): void {
    const id = this.controls.id.value;
    const uuid = this.controls.uuid.value;
    if (id || uuid) {
      // Update the existing row
      this.eventCategoryService.patchById(uuid ? uuid : id, this.eventCategoryFormGroup.value)
        .subscribe(result => {
          this.SavedMessage(result);
        });
    } else {
      // Create the new row
      this.eventCategoryService.create(this.eventCategoryFormGroup.value).subscribe(result => this.SavedMessage(result));
    }
  }

  public cancel(): void {
    this.eventCategoryFormGroup.reset();
  }

  // All the private methods
  private initialFormGroupSetup(): void {
    // setup the initial form for row entity
    this.eventCategoryFormGroup = this.formBuilder.group({
      uuid: [null],
      id: [null],
      name: [null, [Validators.required, Validators.maxLength(GlobalUtil.Validation.GENERAL_FIELD_MAX_LENGTH)]],
      color: [null, [Validators.required]]
    });
  }

  private SavedMessage(data) {
    this.state.message({ ['EventCategoryIndexUpdate']: true });
    this.closeSlideout();
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
